import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  DataTable,
  EmptyState,
  Error,
  Loading,
  Pagination,
} from "@rentiohq/web-shared/dist/components";
import { ts } from "../../../../services";
import { IDocumentsListProps } from "./DocumentList.types";

export const DocumentsList = (props: IDocumentsListProps) => {
  const {
    emptyStateTitle,
    rows,
    page,
    totalPages,
    isLoadingData,
    isFetching,
    fetchError,
    isArchived,
    handlePageClick,
    handleRowClick,
  } = props;

  // Render methods
  const renderPaging = () => {
    if (totalPages <= 1) {
      return;
    }

    return (
      <Pagination
        initialPage={page - 1}
        pageCount={totalPages}
        onPageChange={({ selected }: { selected: number }) => {
          handlePageClick(selected, isArchived);
        }}
      />
    );
  };

  if (fetchError) {
    return (
      <>
        <Error errors={[fetchError]} />
        {renderPaging()}
      </>
    );
  }

  if (isFetching) {
    return (
      <>
        <Loading />
        {renderPaging()}
      </>
    );
  }

  return (
    <>
      <DataTable
        columnContentTypes={["text", "text", "text", "text", "action"]}
        headings={[
          ts.system("name"),
          getLocalizedText("system.contract"),
          ts.uploadDate(),
          ts.propertyDocumentsSharedWithTitle(),
          "",
        ]}
        emptyState={
          <EmptyState backgroundColor="gray" heading={emptyStateTitle} />
        }
        rows={rows}
        // sortable={[true, true, true]}
        // onSort={handleSort}
        isLoadingData={isLoadingData}
        asDots={true}
        onRowClick={(rowIndex: number) => {
          handleRowClick(rowIndex, isArchived);
        }}
      />
      {renderPaging()}
    </>
  );
};
